/**
 * Local dock props (Feeney task, spec p.9 item 6: "limited number of
 * peripheral, generic props").
 *
 * Placeholder accessories for dock mode until Feeney publishes real ones:
 * simple authored models under assets/models/dock-props (localAsset pattern,
 * same as the Kelly panels). The whole set is skipped as soon as the backend
 * catalog contains ANY accessory with application='dock' — real content
 * replaces the placeholders wholesale.
 */

const DOCK_PROPS = [
  { key: 'cleat', description: 'dock cleat', height: 13.5, width: 30, length: 9 },
  { key: 'life_ring', description: 'life ring', height: 90, width: 56, length: 12 },
  { key: 'dock_box', description: 'dock box', height: 58, width: 121, length: 60 },
  { key: 'ladder', description: 'dock ladder', height: 95, width: 48, length: 4 },
  { key: 'bench', description: 'bench', height: 45.5, width: 150, length: 40 }
];

export function mergeLocalDockProps(apiProducts: any[]): any[] {
  const products = apiProducts || [];

  const backendHasDockProps = products.some(
    p => p && p.productType === 'Accessory' && p.application === 'dock'
  );
  if (backendHasDockProps) {
    return products;
  }

  const extras = DOCK_PROPS.map(prop => ({
    id: 'local_dock_prop_' + prop.key,
    productType: 'Accessory',
    productGroup: 'Generic',
    application: 'dock',
    description: prop.description,
    height: prop.height,
    width: prop.width,
    length: prop.length,
    modelObj: 'dock-props/' + prop.key + '.obj',
    modelMtl: 'dock-props/' + prop.key + '.mtl',
    productImg: 'dock-props/' + prop.key + '.png',
    localAsset: true
  }));

  return [...products, ...extras];
}



// WEBPACK FOOTER //
// ./src/app/models/2d3d/dock-props-local.config.ts